<template>
  <v-dialog scrollable class="dialog" v-model="config.status.active" max-width="600px">
    <v-card>
      <v-card-title class="primary blue-grey--text text--darken-4">
        <span class="headline">手配内容の変更</span>
      </v-card-title>
      <v-card-text>
        <v-form lazy-validation
          ref="form"
          v-model="form.valid">
          <EditLayout ref="inputs" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary"
          @click="submit"
          :loading="isLoading"
          :disabled="!isValid">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EditLayout from '../../../layouts/edit'
export default {
  name: 'cli-arranges-toolkit-modals-edit-single',
  components: {
    EditLayout
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        }
      },
      form: {
        valid: true
      }
    }
  },
  methods: {
    preSubmit: function () {
      const fd = this.$refs.inputs.getFormData()
      if (this.$refs.form.validate() && fd.id) {
        this.$set(this.config.status, 'loading', true)
        return {
          fd,
          url: `${this.$url.api}client/update/arrange/${fd.id}`
        }
      } else {
        return false
      }
    },
    submit: function () {
      const dt = this.preSubmit()
      if (dt) {
        const { url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const socket = this.$store.getters['config/get']('socket')
      const cid = this.$route.params.id
      if (!socket.connected) {
        socket.connect()
      }
      socket.emit('POST_ARRANGE', {
        type: 'update',
        item: Object.assign({}, { cid }, req),
        user: this.$store.getters['author/get']('userid')
      }, (res) => {
        console.log(res)
        this.$set(this.config.status, 'loading', false)
        this.close()
      })
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    open: function (req) {
      const { item } = req || {}
      if (item) {
        this.$set(this.config.status, 'active', true)
        this.$nextTick(() => {
          this.$refs.inputs.update(item)
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
      this.$emit('close')
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isValid () {
      return this.form.valid
    }
  }
}
</script>
